const API_BASE = process.env.REACT_APP_API_URL || '/api';

class API {
  // Chat endpoints
  async createSession(eventId) {
    const response = await fetch(`${API_BASE}/chat/session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ eventId }),
    });

    if (!response.ok) {
      throw new Error('Failed to create session');
    }

    return response.json();
  }

  async sendMessage(sessionId, message) {
    const response = await fetch(`${API_BASE}/chat/message`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sessionId, message }),
    });

    if (!response.ok) {
      throw new Error('Failed to send message');
    }

    return response.json();
  }

  async getSession(sessionId) {
    const response = await fetch(`${API_BASE}/chat/session/${sessionId}`);

    if (!response.ok) {
      throw new Error('Failed to get session');
    }

    return response.json();
  }

  async completeSession(sessionId) {
    const response = await fetch(`${API_BASE}/chat/complete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sessionId }),
    });

    if (!response.ok) {
      throw new Error('Failed to complete session');
    }

    return response.json();
  }

  async resetSession(sessionId) {
    const response = await fetch(`${API_BASE}/chat/reset`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sessionId }),
    });

    if (!response.ok) {
      throw new Error('Failed to reset session');
    }

    return response.json();
  }

  // Events endpoints
  async getEvents() {
    const response = await fetch(`${API_BASE}/events`);

    if (!response.ok) {
      throw new Error('Failed to fetch events');
    }

    return response.json();
  }

  async recordEventInterest(sessionId, eventIds) {
    const response = await fetch(`${API_BASE}/events/interest`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sessionId, eventIds }),
    });

    if (!response.ok) {
      throw new Error('Failed to record event interest');
    }

    return response.json();
  }

  // Form endpoints (no AI - direct submission)
  async createFormSession(eventId) {
    const response = await fetch(`${API_BASE}/form/session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ eventId }),
    });

    if (!response.ok) {
      throw new Error('Failed to create form session');
    }

    return response.json();
  }

  async getFormSession(sessionId) {
    const response = await fetch(`${API_BASE}/form/session/${sessionId}`);

    if (!response.ok) {
      throw new Error('Failed to get form session');
    }

    return response.json();
  }

  async updateFormResponse(sessionId, data) {
    const response = await fetch(`${API_BASE}/form/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sessionId, data }),
    });

    if (!response.ok) {
      throw new Error('Failed to update form response');
    }

    return response.json();
  }

  async submitFormResponse(sessionId, data) {
    const response = await fetch(`${API_BASE}/form/submit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sessionId, data }),
    });

    if (!response.ok) {
      throw new Error('Failed to submit form response');
    }

    return response.json();
  }
}

export default new API();
